import {
  getHistory,
  getHistoryByChatId,
  ratingMessage,
  sendChat,
} from '@cockpitai/integration/chat/resources.ts'
import { useMutation, useQuery } from '@tanstack/react-query'
import { KEY_CHAT_HISTORY, KEY_CHAT_HISTORY_BY_ID } from './keys'

export function useRatingMessageMutation() {
  return useMutation({
    mutationFn: ratingMessage,
  })
}

export function useSendChatMutation() {
  return useMutation({
    mutationFn: sendChat,
    retryDelay: 120 * 1000,
  })
}

export function useGetHistoryQuery() {
  return useQuery({
    queryKey: [KEY_CHAT_HISTORY],
    queryFn: getHistory,
  })
}

export function useGetHistoryByChatIdQuery(chatId?: number) {
  return useQuery({
    queryKey: [KEY_CHAT_HISTORY_BY_ID, chatId],
    queryFn: () => getHistoryByChatId(chatId),
    enabled: !!chatId,
  })
}
